module.exports = __webpack_public_path__ + "web_static/img/blue_underline_gif.f9a60e1c.gif";